// extracted by mini-css-extract-plugin
export default {"mypage_subsc_container":"main_mypage_subsc_container__OEw34"};